import { EServiceId } from '../../types/reducers/publishTerms';
import { actionGenerator, IReduxAction } from '../../utils/actions';

export const SELECT_PUBLISH_TERMS_SERVICE = 'PUBLISH_TERMS :: SELECT_SERVICE';

export type TSelectPublishTermsServiceAction = IReduxAction<typeof SELECT_PUBLISH_TERMS_SERVICE, EServiceId>;

export const selectPublishTermsService = actionGenerator<typeof SELECT_PUBLISH_TERMS_SERVICE, EServiceId>(
  SELECT_PUBLISH_TERMS_SERVICE,
);
